module.exports = __webpack_public_path__ + "static/53import-de940b3ec1f27bf657836b559150192b.png";